import React, { useState } from 'react';
import { X } from 'lucide-react';
import { crearCliente } from '../api';

const ClienteModal = ({ isOpen, onClose, onRefresh }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    contacto_nombre: ''
  });

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await crearCliente(formData);
      onRefresh();
      setFormData({ nombre: '', telefono: '', contacto_nombre: '' });
      onClose();
    } catch (error) {
      console.error("Error al crear cliente:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-[400px] shadow-xl">
        <div className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
          <h2 className="font-bold text-gray-700 uppercase text-sm">Registrar Nuevo Cliente</h2>
          <X className="cursor-pointer text-gray-400 hover:text-gray-600" onClick={onClose} />
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Nombre de la Empresa</label>
            <input 
              type="text" 
              required 
              className="w-full border rounded p-2 text-sm outline-emeral-green"
              value={formData.nombre}
              onChange={(e) => setFormData({...formData, nombre: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Teléfono General</label>
            <input 
              type="text" 
              className="w-full border rounded p-2 text-sm outline-emeral-green"
              value={formData.telefono}
              onChange={(e) => setFormData({...formData, telefono: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Punto de Contacto</label>
            <input 
              type="text" 
              placeholder="Ej: Gerente RRHH"
              className="w-full border rounded p-2 text-sm outline-emeral-green"
              value={formData.contacto_nombre}
              onChange={(e) => setFormData({...formData, contacto_nombre: e.target.value})}
            />
          </div>
          
          <div className="pt-4 flex justify-end gap-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-xs font-bold text-gray-400 uppercase">Cancelar</button>
            <button type="submit" className="bg-emeral-green text-white px-6 py-2 rounded text-xs font-bold uppercase hover:bg-opacity-90">
              Guardar Cliente
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClienteModal;
